import { svg } from "lit";
const icon = svg `<path d="M28.8 23.9992C28.8 26.6502 26.6509 28.7992 24 28.7992C21.349 28.7992 19.2 26.6502 19.2 23.9992C19.2 21.3483 21.349 19.1992 24 19.1992C26.6509 19.1992 28.8 21.3483 28.8 23.9992Z" fill="currentColor"/>`;
export default icon;
